import { ChangeEvent } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { useAppDispatch, useAppSelector } from '~/redux/hooks'

import { StatisticsFilters } from '~/analytics/statistics/statisticsEvents.types'

import { IUser } from '~/types/user-info-types'

import {
  selectLearningStatsFilter,
  setLearningProductCategoryFilter,
  setLearningTimeFilter,
} from '../../redux/statistics.slice'
import { CardTimePeriodFilterOptions, MathCategoryFilterOptions } from '../../types/profile-card.types'

import SelectOptions from '../SelectOptions'

import LearningList from './LearningList'
import UserProfile from './UserProfile'

export default function LearningCard({ user }: { user?: IUser }): React.ReactElement {
  const dispatch = useAppDispatch()
  const { timeFilter, productCategoryFilter } = useAppSelector(selectLearningStatsFilter)

  const onChangeProfileCardOption = (e: ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.target
    statisticsAnalytics.logFilterChange(StatisticsFilters.LEARNING_TAB_TIME, value)

    dispatch(setLearningTimeFilter(value))
  }

  const onChangeProductCategoryOption = (e: ChangeEvent<HTMLSelectElement>): void => {
    const { value } = e.target
    statisticsAnalytics.logFilterChange(StatisticsFilters.LEARNING_TAB_PRODUCT, value)

    dispatch(setLearningProductCategoryFilter(value))
  }

  return (
    <div className="w-full p-2 md:p-4 text-center">
      <SelectOptions
        className="w-44"
        onChange={onChangeProfileCardOption}
        options={CardTimePeriodFilterOptions}
        selectedFilter={timeFilter}
      />
      <UserProfile familyMember={user} />
      <div className="mt-4 w-full h-0.5 bg-purple-light" />
      <SelectOptions
        className="w-72 my-1"
        onChange={onChangeProductCategoryOption}
        options={MathCategoryFilterOptions}
        selectedFilter={productCategoryFilter}
        translationPrefix="productCategoryFilters"
      />
      <LearningList user={user} />
    </div>
  )
}
